module.exports = __webpack_public_path__ + "static/media/CreateReturn2.3183498c.png";